export const STUDENT_ACTIVITY_COLUMN_HEADERS = Object.freeze({
  STUDENT_NAME: 'Student Name',
  LAST_ACTIVITY_LAUNCH: 'Last Activity Launch',
});
